import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Calendar, SocialNetworkIcon, ButtonBar } from 'components';
import { FlyoutSection } from 'containers';
import { LLCheckbox } from 'components/FormElements';
import styles from './PartnersFilterPanel.scss';
import { setClientFilter, toggleClientType } from 'redux/modules/teamManagement';
var PartnersFilterPanel = (_dec = connect(function (state) {
  return {
    theme: state.theme,
    user: state.auth.user,
    clientType: state.teamManagement.clientType,
    selectedColumns: state.teamManagement.selectedClientTableColumns
  };
}, {
  toggleClientType: toggleClientType,
  setClientFilter: setClientFilter
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PartnersFilterPanel, _Component);

  var _super = _createSuper(PartnersFilterPanel);

  function PartnersFilterPanel() {
    var _this;

    _classCallCheck(this, PartnersFilterPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleFilterToggle", function (state, item) {
      _this.props.setClientFilter(item.key, state);
    });

    _defineProperty(_assertThisInitialized(_this), "renderSection", function (_ref, index) {
      var key = _ref.key,
          name = _ref.name,
          selected = _ref.selected;
      return /*#__PURE__*/React.createElement("span", {
        key: key
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(LLCheckbox, {
        label: name,
        checked: selected,
        onChange: function onChange(val) {
          _this.props.onChange(key, val);
        }
      })));
    });

    return _this;
  }

  _createClass(PartnersFilterPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: styles.filters
      }, /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "SHOW COLUMNS"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '8px 24px'
        }
      }, this.props.columns.map(function (section, i) {
        return _this2.renderSection(section, i);
      }))));
    }
  }]);

  return PartnersFilterPanel;
}(Component)) || _class);
export { PartnersFilterPanel as default };